import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { api } from '@/lib/api';

interface FavoriteStore {
  favorites: string[]; // Prompt IDs
  isLoading: boolean;

  // Actions
  loadFavorites: () => Promise<void>;
  addFavorite: (promptId: string) => Promise<void>;
  removeFavorite: (promptId: string) => Promise<void>;
  isFavorite: (promptId: string) => boolean;
}

export const useFavoriteStore = create<FavoriteStore>()(
  persist(
    (set, get) => ({
      favorites: [],
      isLoading: false,

      loadFavorites: async () => {
        try {
          set({ isLoading: true });
          const response = await api.favorites.list();
          const favoriteIds = response.data?.favorites.map((f: any) => f.prompt_id) || [];
          set({ favorites: favoriteIds, isLoading: false });
        } catch (error) {
          console.error('Failed to load favorites:', error);
          set({ isLoading: false });
        }
      },

      addFavorite: async (promptId: string) => {
        try {
          await api.favorites.add(promptId);
          set((state) => ({
            favorites: [...state.favorites, promptId],
          }));
        } catch (error) {
          console.error('Failed to add favorite:', error);
          throw error;
        }
      },

      removeFavorite: async (promptId: string) => {
        try {
          await api.favorites.remove(promptId);
          set((state) => ({
            favorites: state.favorites.filter((id) => id !== promptId),
          }));
        } catch (error) {
          console.error('Failed to remove favorite:', error);
          throw error;
        }
      },

      isFavorite: (promptId: string) => {
        return get().favorites.includes(promptId);
      },
    }),
    {
      name: 'favorite-storage',
      partialize: (state) => ({ favorites: state.favorites }),
    }
  )
);

